import { render, staticRenderFns } from "./DatosPacienteHC.vue?vue&type=template&id=574a9fcc&scoped=true"
import script from "./DatosPacienteHC.vue?vue&type=script&lang=js"
export * from "./DatosPacienteHC.vue?vue&type=script&lang=js"
import style0 from "./DatosPacienteHC.vue?vue&type=style&index=0&id=574a9fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a9fcc",
  null
  
)

export default component.exports